export const appRouterPaths: string[] = [
    '/trump',
    '/sports',
    '/grammys',
    '/',
    '/calendar',
    '/markets',
    '/ss-two-factor-code',
];
